module.exports = __webpack_public_path__ + "static/img/iStock-597651824.320b6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iStock-597651824.png
// module id = 1721
// module chunks = 5